import { render } from "./InCallCancel.vue?vue&type=template&id=4b38a1c0"
import script from "./InCallCancel.vue?vue&type=script&lang=js"
export * from "./InCallCancel.vue?vue&type=script&lang=js"

import "./InCallCancel.vue?vue&type=style&index=0&id=4b38a1c0&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__